import type { SVGComponentProps } from 'BreetHelpers';

export const ReportIcon = ({ ...rest }: SVGComponentProps) => (
	<svg
		width='41'
		height='41'
		viewBox='0 0 41 41'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
		{...rest}
	>
		<rect
			x='0.5'
			y='0.5'
			width='40'
			height='40'
			rx='20'
			fill='var(--color-neutral-200)'
		/>
		<path
			opacity='0.4'
			d='M13.8333 21.1466V17.1599C13.8333 15.3199 15.3266 13.8333 17.1666 13.8333H23.8333C25.6733 13.8333 27.1666 15.3199 27.1666 17.1599V21.8133C27.1666 23.6466 25.6733 25.1333 23.8333 25.1333H22.8333C22.6266 25.1333 22.4266 25.2333 22.2999 25.3999L21.2999 26.7266C20.8599 27.3133 20.1399 27.3133 19.6999 26.7266L18.6999 25.3999C18.5933 25.2533 18.3533 25.1333 18.1666 25.1333H17.1666C15.3266 25.1333 13.8333 23.6466 13.8333 21.8133V21.1466Z'
			fill='#748181'
		/>
		<path
			d='M20.4999 20.5001C20.1266 20.5001 19.8333 20.2001 19.8333 19.8334C19.8333 19.4667 20.1333 19.1667 20.4999 19.1667C20.8666 19.1667 21.1666 19.4667 21.1666 19.8334C21.1666 20.2001 20.8733 20.5001 20.4999 20.5001Z'
			fill='#748181'
		/>
		<path
			d='M23.1667 20.5001C22.7933 20.5001 22.5 20.2001 22.5 19.8334C22.5 19.4667 22.8 19.1667 23.1667 19.1667C23.5333 19.1667 23.8333 19.4667 23.8333 19.8334C23.8333 20.2001 23.54 20.5001 23.1667 20.5001Z'
			fill='#748181'
		/>
		<path
			d='M17.8334 20.5001C17.4601 20.5001 17.1667 20.2001 17.1667 19.8334C17.1667 19.4667 17.4667 19.1667 17.8334 19.1667C18.2001 19.1667 18.5001 19.4667 18.5001 19.8334C18.5001 20.2001 18.2067 20.5001 17.8334 20.5001Z'
			fill='#F7F8F8'
		/>
	</svg>
);
